import { popperTriggerProps as C } from "./index561.js";
import { defineComponent as x, inject as y, computed as d, onMounted as B, watch as p, onBeforeUnmount as L, openBlock as T, createBlock as _, unref as w, mergeProps as F, withCtx as P, renderSlot as R, createCommentVNode as A } from "vue";
import { unrefElement as k } from "./index562.js";
import { POPPER_INJECTION_KEY as I } from "./index558.js";
import { useForwardRef as M } from "./index563.js";
import { OnlyChild as O } from "./index564.js";
import { isElement as l } from "./index565.js";
import { isFocusable as b } from "./index566.js";
import S from "./index567.js";
var W = /* @__PURE__ */ x({
  name: "ElPopperTrigger",
  inheritAttrs: !1,
  __name: "trigger",
  props: C,
  setup(f, { expose: g }) {
    const i = f, { role: u, triggerRef: a } = y(I, void 0);
    M(a);
    const m = d(() => s.value ? i.id : void 0), v = d(() => {
      if (u && u.value === "tooltip")
        return i.open && i.id ? i.id : void 0;
    }), s = d(() => {
      if (u && u.value !== "tooltip")
        return u.value;
    }), h = d(() => s.value ? `${i.open}` : void 0);
    let n;
    const c = [
      "onMouseenter",
      "onMouseleave",
      "onClick",
      "onKeydown",
      "onFocus",
      "onBlur",
      "onContextmenu"
    ];
    return B(() => {
      p(
        () => i.virtualRef,
        (e) => {
          e && (a.value = k(e));
        },
        {
          immediate: !0
        }
      ), p(
        a,
        (e, o) => {
          n?.(), n = void 0, l(o) && c.forEach((r) => {
            const t = i[r];
            t && o.removeEventListener(
              r.slice(2).toLowerCase(),
              t,
              ["onFocus", "onBlur"].includes(r)
            );
          }), l(e) && (c.forEach((r) => {
            const t = i[r];
            t && e.addEventListener(
              r.slice(2).toLowerCase(),
              t,
              ["onFocus", "onBlur"].includes(r)
            );
          }), b(e) && (n = p(
            [m, v, s, h],
            (r) => {
              [
                "aria-controls",
                "aria-describedby",
                "aria-haspopup",
                "aria-expanded"
              ].forEach((t, E) => {
                S(r[E]) ? e.removeAttribute(t) : e.setAttribute(t, r[E]);
              });
            },
            { immediate: !0 }
          ))), l(o) && b(o) && [
            "aria-controls",
            "aria-describedby",
            "aria-haspopup",
            "aria-expanded"
          ].forEach((r) => o.removeAttribute(r));
        },
        {
          immediate: !0
        }
      );
    }), L(() => {
      if (n?.(), n = void 0, a.value && l(a.value)) {
        const e = a.value;
        c.forEach((o) => {
          const r = i[o];
          r && e.removeEventListener(
            o.slice(2).toLowerCase(),
            r,
            ["onFocus", "onBlur"].includes(o)
          );
        }), a.value = void 0;
      }
    }), g({
      /**
       * @description trigger element
       */
      triggerRef: a
    }), (e, o) => f.virtualTriggering ? A("v-if", !0) : (T(), _(w(O), F({ key: 0 }, e.$attrs, {
      "aria-controls": m.value,
      "aria-describedby": v.value,
      "aria-expanded": h.value,
      "aria-haspopup": s.value
    }), {
      default: P(() => [
        R(e.$slots, "default")
      ]),
      _: 3
      /* FORWARDED */
    }, 16, ["aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup"]));
  }
});
export {
  W as default
};
